import * as eff from 'redux-saga/effects';

export function* throwError(error: any): Generator<any, void, any> {
  yield eff.call(console.error, error);
}

export const getEntityType = (resourceType: string): string => {
  const types: { [k: string]: string } = {
    exercises: 'exercises',
    personalExercises: 'personal_exercises',
    workoutTemplates: 'workout_templates',
    warmups: 'workout_templates',
    cooldowns: 'workout_templates',
    programTemplates: 'program_templates',
    workoutExercises: 'workout_exercises',
    exerciseProperties: 'exercise_properties',
    personalWorkouts: 'personal_workouts',
    personalWarmups: 'personal_warmups',
    personalPrograms: 'personal_programs',
    personalProperties: 'personal_properties',
    personalCooldowns: 'personal_cooldowns',
    programWeeks: 'program_weeks',
    programWorkouts: 'program_workouts',
    clients: 'clients',
    clientGroups: 'client_groups',
    exerciseResults: 'exercise_results',
    workoutEvents: 'workout_events',
    users: 'users',
    userAuthentications: 'user_authentications',
    archivedClients: 'clients/archived',
    productPlans: 'product_plans',
    activityLogs: 'activity_logs',
  };

  return types[resourceType] || resourceType;
};
